import React, { useEffect, useState } from 'react'
import { Typography, Box, Grid, Dialog, DialogContent, useMediaQuery, Stack, Snackbar, Alert, IconButton } from '@mui/material';
import CloseModalIcon from '../../../icons/RoundCloseIcon.svg'
import moment from 'moment';
import SendEmailIcon from '../../../icons/SendEmailIcon.svg';
import ResendRequest from '../../../icons/ResendRequest.svg'
import SpinnerModal from '../../../shared/Modal/SpinnerModal';
import { getResendRequest, selectPaymentRequestsState } from '../sagas/paymentrequestslice';
import { useDispatch, useSelector } from 'react-redux';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

interface ResendModalProps {
    open: boolean;
    onClose: () => void;
    lastSentDate: string;
    requestId: string;
    Email: string;
}

const ResendModal = (props: ResendModalProps) => {
    const dispatch = useDispatch();
    const [email, setEmail] = React.useState(props?.Email);
    const [invitationError, setInvitationError] = useState('');
    const [isSpinnerModalOpen, setIsSpinnerModalOpen] = useState(false);
    const [spinnerStatus, setSpinnerStatus] = useState<string | null>(null);
    const { isResendingRequestSuccess, resendRequestError } = useSelector(selectPaymentRequestsState);

    const { Email, lastSentDate, requestId } = props
    const handleCloseSpinnerModal = () => {
        setIsSpinnerModalOpen(false);
    }

    const isOnMobileScreen = useMediaQuery("(max-width:600px)");
    const style = {
        height: isOnMobileScreen ? '' : '555px'
    };

    const handleInvitationEmail = () => {
        setIsSpinnerModalOpen(true);
        dispatch({
            type: getResendRequest.type,
            payload: {
                PaymentRequestId: requestId,
                PayerEmail: email
            }
        })
    }

    useEffect(() => {
        setEmail(Email)
    }, [Email])

    //spinner and error handling
    useEffect(() => {
        if (isResendingRequestSuccess) {
            setInvitationError('')
            setSpinnerStatus('stop');
        }
    }, [isResendingRequestSuccess]);

    useEffect(() => {
        if (resendRequestError?.message?.length > 0) {
            setIsSpinnerModalOpen(false);
            setInvitationError(resendRequestError?.message);
        }
    }, [resendRequestError])

    const [snackBarOpen, setSnackBarOpen] = React.useState(false);

    return (
        <React.Fragment>
            <Dialog
                open={props.open}
                onClose={() => {
                    props.onClose()
                    setInvitationError('')
                }}
                fullScreen={isOnMobileScreen}
                BackdropProps={{
                    invisible: false
                }}
                fullWidth={true}
                disableEnforceFocus
                style={{
                    background: "none",
                }}
                PaperProps={{
                    style: {
                        pointerEvents: "auto",
                        width: '520px',
                        borderRadius: '24px'
                    },
                }}
                disableEscapeKeyDown={true}
            >
                <DialogContent>
                    <Box
                        sx={style}
                    >
                        <Grid container spacing={3} justifyContent="center">
                            <Grid item xs={2}> </Grid>
                            <Grid item xs={8}>
                                <Typography
                                    align='center'
                                    sx={{
                                        fontWeight: 600,
                                        fontSize: "18px",
                                        lineHeight: "22px",
                                        fontFamily: "Work Sans",
                                    }}>
                                    Resend Request
                                </Typography>
                            </Grid>
                            <Grid item xs={2}>
                                <img src={CloseModalIcon} alt="close" style={{ cursor: 'pointer', marginLeft: isOnMobileScreen ? "0px" : "40px" }} onClick={() => {
                                    props.onClose()
                                    setInvitationError('')
                                }} />
                            </Grid>
                            {invitationError?.length ?
                                <Grid item sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: 'center',
                                    borderTop: "2px  solid #DB3939",
                                    borderRadius: '24px',
                                    padding: "12px 20px",
                                    width: '340px',
                                    height: '49px',
                                }} >
                                    <Typography
                                        sx={{
                                            fontFamily: "'Open Sans', sans-serif",
                                            fontStyle: 'normal',
                                            fontWeight: 500,
                                            fontSize: '14px',
                                            lineHeight: '18px',
                                            color: '#DB3939'
                                        }}>
                                        {invitationError}
                                    </Typography>
                                </Grid> : ""
                            }
                            <Grid item xs={12} display='flex' justifyContent='center'>
                                <img src={ResendRequest} style={{ maxWidth: 120 }} alt='resendrequest' />
                            </Grid>
                            
                            <Box sx={{
                                background: '#F1F0F5',
                                borderRadius: '24px',
                                padding: '12px 16px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                position: 'relative',
                                marginTop: '25px',
                            }}>
                                <Typography 
                                    sx={{
                                        fontFamily: "Work Sans",
                                        fontStyle: 'normal',
                                        fontWeight: 400,
                                        fontSize: '16px',
                                        lineHeight: '22px',
                                        color: '#14142B',
                                        width: 'calc( 100% - 80px )',
                                        textAlign: 'center',
                                    }}
                                >
                                    Click to copy the link and send yourself
                                </Typography>
                                <IconButton
                                    edge="start"
                                    color="inherit"
                                    aria-label="Copy special code"
                                    onClick={() => {
                                        navigator.clipboard.writeText(`${window.location.origin}/makepayment?paymentrequestid=${requestId}`);
                                        setSnackBarOpen(true);
                                    }}
                                    sx={{
                                        position: 'absolute',
                                        right: 5,
                                    }}
                                >
                                    <ContentCopyIcon sx={{ width: '22px', height: '22px', fill: '#14142B' }} />
                                </IconButton>
                            </Box>

                            <Grid item xs={12}>
                                <Typography
                                    align='center'
                                    sx={{
                                        fontWeight: 400,
                                        fontSize: "18px",
                                        lineHeight: "22px",
                                        fontFamily: "Work Sans",
                                    }}>
                                    Click the button to send to the email address below.
                                </Typography>
                            </Grid>
                            <div style={{ position: "relative", display: "inline-block", marginTop: '20px' }}>
                                <input
                                    type="text"
                                    style={{
                                        background: "#FFF",
                                        borderRadius: "24px",
                                        height: "57px",
                                        width: "360px",
                                        padding: "17px",
                                        border: '1px solid #F1F0F5',
                                        outline: "none",
                                        zIndex: 1,
                                        fontFamily: '"Work Sans",Sans serif',
                                        fontStyle: 'normal',
                                        fontWeight: 400,
                                        fontSize: '18px',
                                        lineHeight: '22px'
                                    }}
                                    placeholder='Email'
                                    value={email}
                                    onChange={(e: any) => setEmail(e.target.value)}
                                />
                                <div style={{
                                    background: email.length === 0 ? '#D3D3D3' : '#39A2DB',
                                    borderRadius: '24px',
                                    position: "absolute",
                                    right: 0,
                                    top: 0,
                                    width: 62,
                                    height: 57,
                                    pointerEvents: email.length === 0 ? 'none' : 'auto',
                                    cursor: 'pointer'
                                }} onClick={handleInvitationEmail}>
                                    <Stack direction="row" justifyContent="center" alignItems="center" spacing={1}>
                                        <img src={SendEmailIcon}
                                            style={{
                                                position: "absolute",
                                                top: 20,
                                                height: '20px',
                                                width: '20px',
                                                cursor: 'pointer'
                                            }}
                                            alt="resendpr"
                                        />
                                    </Stack>
                                </div>
                            </div>
                            <Grid item xs={12}>
                                <Typography
                                    align='center'
                                    sx={{
                                        fontWeight: 400,
                                        fontSize: "18px",
                                        lineHeight: "22px",
                                        fontFamily: "Work Sans",
                                    }}>
                                    {lastSentDate ? `Last Requested: ${moment(lastSentDate).format("LLLL")}` : ''}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>
                </DialogContent>
                {
                    isSpinnerModalOpen ? (
                        <SpinnerModal
                            openSpinnerModal={isSpinnerModalOpen}
                            handleCloseSpinnerModal={handleCloseSpinnerModal}
                            spinnerStatus={spinnerStatus}
                            closeCancel={() => { }}
                            isInvisible={true}
                            width='520px'
                            height="555px"
                        />
                    ) : <></>
                }
            </Dialog>

            <Snackbar anchorOrigin={{ horizontal: 'center', vertical: 'top' }} open={snackBarOpen} autoHideDuration={4000} onClose={() => {setSnackBarOpen(false)}}>
                <Alert onClose={() => {setSnackBarOpen(false)}} severity="success" sx={{ width: '100%' }}>
                    Copied to Clipboard
                </Alert>
            </Snackbar>
        </React.Fragment >
    )
}

export default ResendModal;
